import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HammerGestureConfig } from '@angular/platform-browser';

import * as Hammer from 'hammerjs';

@Injectable({
  providedIn: 'root'
})
export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  } as any;
}

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class HammerModule { }
